import { bootstrapApplication } from '@angular/platform-browser';

import { CelumPropertiesProvider } from '@celum/core';
import { prepareApplicationInsights } from '@celum/shared/shared';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

prepareApplicationInsights()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch(err => console.error(err));

window.onload = () => {
  // let's add our favicon in case we are on the default domain
  const currentUrl = window.location.href;
  if (currentUrl.startsWith(CelumPropertiesProvider.properties.appProperties.portals.url)) {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = 'favicon-celum.ico';
    document.head.appendChild(link);
  }
};
